import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9324990c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "payment_wrap" }
const _hoisted_2 = { id: "payment_btns" }
const _hoisted_3 = {
  key: 0,
  class: "black_txt"
}

import Row from '../RowSection.vue';
    import useStore from '@/store';
    import { inject, reactive, watch, watchEffect } from 'vue';
    import {
        PaymentProcessingOptions,
        PaymentMethodTypes,
        GPayConfiguration,
        ApplePayConfiguration,
    } from '@/typings/paymentMethods';
    import GoogleClient from '@/services/GoogleClient';
    import { BasicTransactionInfo } from '@/models/landingPage';
    import AppleClient from '@/services/AppleClient';
    import PaymentButton from './PaymentButton.vue';
    import PaymentSeparator from './PaymentSeparator.vue';
    import { computed } from '@vue/reactivity';
    import applePay from '@/assets/images/payment/applePay_logo.svg';
    import svgGPay from '@/assets/images/payment/GPay.svg';
    import svgVisa from '@/assets/images/payment/visa.svg';
    import svgMastercard from '@/assets/images/payment/mastercard.svg';
    interface PaymentMethod {
        id: string;
        btnClass: string;
        icons: any[];
        isSupported: boolean;
        extraCondition?: undefined | Function;
        txt?: undefined | string;
        onClick: (_a: PaymentProcessingOptions) => void;
    }
    //props
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethods',
  props: {
    transactionInfo: null,
    machineName: null,
    paymentMethods: null
  },
  setup(__props: any) {

const props = __props as {
        transactionInfo: BasicTransactionInfo;
        machineName: string;
        paymentMethods?: { [key in PaymentMethodTypes]?: PaymentProcessingOptions };
    }

    const loaderStyle = { background: 'rgb(34 34 34 / 50%)' };
    

    const store = useStore();
    const $t = inject('$t', (value: string) => value);

    let googleClient: GoogleClient | null = null;
    let appleClient: AppleClient | null = null;

    const stopWatchingGPay = watchEffect(
        () => {
            if (store.scripts.gPay != null) {
                stopWatchingGPay();
                if (store.scripts.gPay && props.paymentMethods?.gPay?.configuration)
                    googleClient = new GoogleClient(
                        props.paymentMethods.gPay?.configuration as GPayConfiguration,
                        () => {
                            const pm = paymentConfigurations.gPay;
                            if (pm) pm.isSupported = true;
                        }
                    );
            }
        },
        { flush: 'post' }
    );

    const stopWatchingApple = watchEffect(
        () => {
            if (store.scripts.applePay != null) {
                stopWatchingApple();
                if (store.scripts.applePay && props.paymentMethods?.applePay?.configuration)
                    appleClient = new AppleClient(
                        props.paymentMethods?.applePay?.configuration as ApplePayConfiguration,
                        props.machineName
                    );
                const pm = paymentConfigurations.applePay;
                if (pm) pm.isSupported = AppleClient.isSupported();
            }
        },
        { flush: 'post' }
    );

    //methods
    const onClick = (pm: PaymentMethod, key: PaymentMethodTypes) => {
        const current = props.paymentMethods?.[key];
        if (current) pm.onClick(current);
    };

    //reactive
    const paymentConfigurations = reactive<{ [key in PaymentMethodTypes]: PaymentMethod }>({
        [PaymentMethodTypes.APPLE_PAYMENT_METHOD]: {
            id: 'checkoutAppleBtn',
            btnClass:
                'btn btn-outline-dark payment_btn apple-pay-button apple-pay-button-white-with-line',
            icons: [applePay],
            isSupported: false,
            onClick: (options: PaymentProcessingOptions) => {
                if (options?.onLoaded?.() === false) {
                    // console.log(`On loaded returned false for ${paymentMethod}. Returning...`);
                    return;
                }
                if (!props.transactionInfo) {
                    console.log('No transactionInfo');
                    return;
                }
                if (!appleClient) {
                    console.log('No apple client');
                    return;
                }

                appleClient.pay(
                    props.transactionInfo,
                    options?.onSuccess!,
                    options.gateway ?? 'UNKNOWN'
                );
            },
        },
        [PaymentMethodTypes.GOOGLE_PAYMENT_METHOD]: {
            id: 'checkoutGoogleBtn',
            btnClass: 'btn btn-outline-dark payment_btn gpay-button-dark',
            icons: [svgGPay],
            isSupported: false,
            onClick: (config: PaymentProcessingOptions) => {
                if (config?.onLoaded?.() === false) {
                    // console.log(`On loaded returned false for ${config.}. Returning...`);
                }

                if (!props.transactionInfo) {
                    console.log('No transactionInfo');
                    return;
                }
                if (!googleClient) {
                    console.log('No google client');
                    return;
                }

                const googleTransactionInfo: google.payments.api.TransactionInfo = {
                    countryCode: props.transactionInfo.countryCode,
                    currencyCode: props.transactionInfo.currencyCode,
                    totalPriceStatus: 'FINAL',
                    totalPrice: props.transactionInfo.totalPrice.toString(),
                };

                store.setLoading(true, loaderStyle);
                googleClient.GooglePay(
                    googleTransactionInfo,
                    (token) => {
                        config?.onSuccess!(token).then(() => store.setLoading(false));
                    },
                    (value) => {
                        config?.onFailure?.(value);
                        store.setLoading(false);
                    }
                );
            },
        },

        [PaymentMethodTypes.CREDIT_CARD_PAYMENT_METHOD]: {
            id: 'checkoutBtn',
            btnClass: 'btn btn-outline-dark payment_btn credit_card_payment_btn',
            icons: [svgVisa, svgMastercard],
            txt: $t('Credit Card'),
            isSupported: true,
            onClick: (option) => {
                if (option?.onLoaded?.() === false) {
                    console.log(
                        `On loaded returned false for ${PaymentMethodTypes.CREDIT_CARD_PAYMENT_METHOD}. Returning...`
                    );
                    return;
                }
            },
        },
    });

    //computed
    const supportedPayments = computed(() =>
        Object.entries(paymentConfigurations)
            .map(([key, value]) => ({
                key: key as PaymentMethodTypes,
                value,
            }))
            .filter((a) => a.value.isSupported && props.paymentMethods?.[a.key])
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Row, {
      text: _unref($t)('Pay with') + ':'
    }, null, 8, ["text"]),
    _createVNode(Row, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(supportedPayments), (pm, pmIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: pmIndex }, [
              (pmIndex === 1)
                ? (_openBlock(), _createBlock(PaymentSeparator, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(PaymentButton, {
                id: pm.value.id,
                class: _normalizeClass(pm.value.btnClass),
                onClick: ($event: any) => (onClick(pm.value, pm.key)),
                icons: pm.value.icons
              }, {
                default: _withCtx(() => [
                  (pm.value.txt)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(pm.value.txt), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["id", "class", "onClick", "icons"])
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})